import React, { useCallback, useEffect, useState } from 'react'

// Const
import {
  PATH_ECWT_LIST,
  PATH_NOT_FOUND,
  PATH_TICKET_SUPPORT,
} from 'routes/paths'

// Model
import EcwtModel from 'models/Ecwt'

// Notifications slice
import { markAsRead } from 'store/modules/notifications'

// Use
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import useMounted from 'use/mounted'
import useQuery from 'use/query'

// Api
import { getEcwtInfo } from 'api/ecwt'

//Components
import Header from 'ui/Header'
import Navbar from 'ui/Navbar'
import Container from 'ui/Container'
import Breadcrumb from 'ui/Breadcrumb'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Text from 'ui/Text'
import Skeleton from 'ui/Skeleton'
import EcwtView from 'components/Ecwt/EcwtView'
import NeedHelp from 'components/Ecwt/NeedHelp'

const breadcrumbs = [
  {
    label: 'e-Creditable Withholding Tax',
    path: PATH_ECWT_LIST,
  },
  {
    label: 'e-CWT details',
  },
]

export default function PageEcwtView() {
  const dispatch = useDispatch()
  const isMounted = useMounted()
  const history = useHistory()

  // State
  const [ecwt, setEcwt] = useState(new EcwtModel())
  const [loading, setLoading] = useState(false)
  const { id } = useParams()
  const { notificationId } = useQuery()

  const getData = useCallback(() => {
    getEcwtInfo({ ecwtId: id, notificationId })
      .then((data) => {
        if (isMounted.current) {
          setEcwt(data)
        }
      })
      .catch(() => {
        history.replace(PATH_NOT_FOUND)
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
  }, [history, id, isMounted, notificationId])

  useEffect(() => {
    setLoading(true)

    dispatch(markAsRead(id))

    getData()
  }, [dispatch, getData, history, id, isMounted, notificationId])

  return (
    <>
      <Header />
      <Navbar />
      <Container>
        <Breadcrumb items={breadcrumbs} />
        <Text bold wordBreak color="#000000" size={24} paddingBottom={15}>
          {ecwt.fileName}
        </Text>
        <Row>
          <Col sm={12} md={8}>
            <Skeleton loading={loading}>
              <EcwtView ecwt={ecwt} onRefresh={getData} />
            </Skeleton>
          </Col>
          <Col sm={12} md={4}>
            <NeedHelp
              title="Need help ?"
              onClick={() => {
                history.push({
                  pathname: PATH_TICKET_SUPPORT,
                  search: `?ecwtId=${ecwt.id}`,
                })
              }}
            />
          </Col>
        </Row>
      </Container>
    </>
  )
}
